module.exports = __webpack_public_path__ + "img/ico_play_l.bc108794.png";